// assets/pickeasy-custom.js

document.addEventListener('DOMContentLoaded', function () {

    // ==================== PICKEEASY FULFILLMENT HIDING ====================
    function updateFulfillmentOptions() {
        fetch('/cart.js')
            .then(res => res.json())
            .then(cart => {
                if (cart.items.length === 0) return;

                const productType = cart.items[0].product_type ? cart.items[0].product_type.toLowerCase() : '';
                
                console.log('=== Pickeasy Debug === Product Type:', productType);

                const deliveryOption = document.getElementById('delivery-option-div');
                const pickupOption = document.getElementById('pickup-option-div');
                const shippingOption = document.getElementById('standard-shipping-option-div');

                function setVisible(option, visible) {
                    if (!option) return;
                    const cell = option.closest('.ft-options-cell');
                    if (!cell) return;

                    if (visible) {
                        option.classList.add('ft-options-active');
                        setTimeout(() => option.click(), 150);
                    } else {
                        cell.style.setProperty('display', 'none', 'important');
                        option.classList.remove('ft-options-active');
                    }
                }

                if (productType.includes('shipping') || productType === 'ship') {
                    console.log('→ Shipping-only mode');
                    setVisible(shippingOption, true);
                    setVisible(pickupOption, false);
                    setVisible(deliveryOption, false);
                } 
                else if (productType.includes('pickup') || productType.includes('local')) {
                    console.log('→ Pickup + Local Delivery mode');
                    setVisible(shippingOption, false);
                    setVisible(pickupOption, true);
                    setVisible(deliveryOption, true);
                }
            })
            .catch(err => console.error('Cart fetch error:', err));
    }

    // ==================== ADD TO CART PROTECTION ====================
    function getCartType() {
        return fetch('/cart.js')
            .then(res => res.json())
            .then(cart => {
                if (cart.items.length === 0) return 'empty';
                const type = cart.items[0].product_type ? cart.items[0].product_type.toLowerCase() : '';
                return type.includes('shipping') || type === 'ship' ? 'shipping' : 'pickup';
            })
            .catch(() => 'empty');
    }

    async function disableAddToCartIfMismatch() {
        const cartType = await getCartType();
        if (cartType === 'empty') return;

        // Check current product type (works on product pages)
        const currentProductTypeMeta = document.querySelector('meta[property="og:type"]') || 
                                      document.querySelector('[data-product-type]');
        let currentType = '';

        // Better way: use Liquid-injected data or product JSON
        if (window.product && window.product.type) {
            currentType = window.product.type.toLowerCase();
        } else {
            // Fallback: look for product type in page
            const typeEl = document.querySelector('.product-type, [data-product-type]');
            if (typeEl) currentType = typeEl.textContent.toLowerCase();
        }

        console.log('Current product type:', currentType, '| Cart type:', cartType);

        const isShippingProduct = currentType.includes('shipping') || currentType === 'ship';
        const isPickupProduct = currentType.includes('pickup') || currentType.includes('local');

        const addButtons = document.querySelectorAll('button[name="add"], .add-to-cart, [data-add-to-cart]');

        addButtons.forEach(btn => {
            if ((cartType === 'shipping' && isPickupProduct) || 
                (cartType === 'pickup' && isShippingProduct)) {
                
                btn.disabled = true;
                btn.style.opacity = '0.6';
                btn.style.cursor = 'not-allowed';
                
                // Optional: change text
                if (btn.textContent.toLowerCase().includes('add')) {
                    btn.textContent = 'Cannot mix with current cart';
                }
            }
        });
    }

    // ==================== INIT ====================

    // Pickeasy
    setTimeout(updateFulfillmentOptions, 1200);

    function handleAddToCart() {
        console.log('🛒 Add to Cart clicked → Waiting...');
        setTimeout(updateFulfillmentOptions, 3200);
        setTimeout(updateFulfillmentOptions, 5200);
    }

    // function attachListeners() {
    //     document.querySelectorAll('button[name="add"], .add-to-cart, [data-add-to-cart]').forEach(btn => {
    //         btn.addEventListener('click', handleAddToCart);
    //     });
    // }
    function attachListeners() {
        document.querySelectorAll(
            'button[name="add"], .add-to-cart, [data-add-to-cart]'
        ).forEach(btn => {

            if (btn.dataset.pickeasyListenerAttached) return;

            btn.dataset.pickeasyListenerAttached = 'true';
            btn.addEventListener('click', handleAddToCart);
        });
    }

    attachListeners();
    new MutationObserver(attachListeners).observe(document.body, { childList: true, subtree: true });

    document.addEventListener('cart:updated', () => setTimeout(updateFulfillmentOptions, 3000));

    // Run cart protection on product pages
    setTimeout(disableAddToCartIfMismatch, 800);
    document.addEventListener('cart:updated', disableAddToCartIfMismatch);
});